import { ShieldCheck, BadgeCheck, Clock, MapPin } from "lucide-react";

export const BUSINESS = {
    name: "Appliance Mania Service & Repair LLC",
    shortName: "Appliance Mania",
    domain: "https://appliancemania.net",
    phone: "(321) 475-2230",
    tel: "tel:+13214752230",
    email: "engagement@appliancemania.net",
    counties: ["Brevard County", "Seminole County"],
    serviceCall: "$155 Service Call — Waived With Completed Repair",
    warranty: "6-Month Warranty on Completed Repairs",
};

export const GOOGLE_REVIEWS_URL = "https://g.page/r/Cf1rcQaffZf1EBM";
export const GOOGLE_REVIEW_WRITE_URL = "https://g.page/r/Cf1rcQaffZf1EBM/review";

export const TRUST_CHIPS = [
    { icon: ShieldCheck, title: "$155 Service Call", subtitle: "Waived with completed repair" },
    { icon: BadgeCheck, title: "6-Month Warranty", subtitle: "On completed repairs" },
    { icon: Clock, title: "After-Hours Service", subtitle: "May be available 10 PM – 6 AM" },
    { icon: MapPin, title: "Local & In-Home", subtitle: "Brevard & Seminole Counties" },
];

export const BRANDS = [
    "Whirlpool", "Maytag", "KitchenAid", "GE", "Frigidaire", "Electrolux",
    "LG", "Samsung", "Bosch", "Amana", "Hotpoint",
];

export const PAYMENT_METHODS = ["Credit cards", "Debit cards", "Zelle", "Check", "Cash", "Cash App"];

export const TIME_WINDOWS = [
    "Morning (8 AM – 11 AM)",
    "Midday (11 AM – 2 PM)",
    "Afternoon (2 PM – 5 PM)",
    "Evening (5 PM – 8 PM)",
    "Flexible / first available",
];

export const APPLIANCE_TYPES = [
    "Refrigerator", "Freezer", "Ice Maker", "Washer", "Dryer",
    "Dishwasher", "Oven", "Range / Stove", "Other",
];

export const STEPS = [
    { num: "01", title: "Call or request service", text: "Call (321) 475-2230 or send the online request form. Tell us what your appliance is doing — we will tell you honestly whether we can help." },
    { num: "02", title: "We confirm your appointment", text: "We review every request and contact you to confirm availability and appointment details. Most appointments can be scheduled within about 24 hours, subject to availability." },
    { num: "03", title: "In-home diagnosis & repair", text: "A technician comes to your home, diagnoses the problem, and gives you a clear quote before any work begins. The $155 service call is waived with a completed repair." },
    { num: "04", title: "Backed for 6 months", text: "Completed repairs include a 6-month warranty, so you are not left hoping the fix holds." },
];

export const HOME_FAQS = [
    { q: "How much does a service call cost?", a: "Our standard residential service call is $155 — waived with a completed repair. If you approve the repair and we complete it, you do not pay the service-call fee." },
    { q: "Do you offer same-day or next-day appointments?", a: "Most appointments can be scheduled within about 24 hours, subject to availability. For urgent situations, call (321) 475-2230 and we will tell you honestly what we can do." },
    { q: "Do you offer emergency or after-hours service?", a: "After-hours emergency service may be available from 10 PM to 6 AM. Call (321) 475-2230 for availability." },
    { q: "What areas do you serve?", a: "We provide in-home appliance repair throughout Brevard County and Seminole County, Florida — including Melbourne, Palm Bay, Titusville, Sanford, Lake Mary, Oviedo, and surrounding communities." },
    { q: "What brands do you repair?", a: "We service most major residential brands, including Whirlpool, Maytag, KitchenAid, GE, Frigidaire, Electrolux, LG, Samsung, Bosch, Amana, and Hotpoint." },
    { q: "What payment methods do you accept?", a: "We accept credit cards, debit cards, Zelle, check, cash, and Cash App." },
    { q: "Are completed repairs covered by a warranty?", a: "Yes. Completed repairs include a 6-month warranty." },
];

export const PARTS_NOTE = "We carry many commonly used appliance repair parts. If your repair requires a part we don't have on hand, we can often source it the same day or by the next day.";
